import { Component } from '@angular/core';
import { CampaignService } from '../../../services/campaigns/campaign.service';
import { TreeNode } from 'primeng/api';


@Component({
  selector: 'app-allfailedmails',
  standalone: false,
  templateUrl: './allfailedmails.component.html',
  styleUrl: './allfailedmails.component.css'
})
export class AllfailedmailsComponent {
  data: any[] = [];
  stats: any; 
  constructor(private campaignService: CampaignService) {
    this.campaignService.getCampaignsList().subscribe((data: any) => {
      this.data = data;
    });
    this.campaignService.GetMonthlyStatistics().subscribe((stats: any) => {   
      this.stats = stats;
    });
  }
}
